import Meeting from '@/components/Meeting/Meeting';
import { useFetchUserDataQuery } from '@/store/apis/userApi';
import { Modal, Typography } from 'antd';
import React, { useState, useEffect } from 'react';

interface HealthCheckMeetingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOk: () => void;
}

const HealthCheckMeetingModal: React.FC<HealthCheckMeetingModalProps> = ({
  isOpen,
  onClose,
  onOk,
}) => {
  //object destructuring pulling out data and refetch from useFetchUserDataQuery, renames data to userProfileData
  const { data: userProfileData, refetch } = useFetchUserDataQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const userProfile = userProfileData?.data;

  const [meetingLink, setMeetingLink] = useState('');

  useEffect(() => {
    if (!userProfile) return;
    const params = new URLSearchParams({
      embed: 'true',
      ...(userProfile?.firstName && { firstname: userProfile?.firstName }),
      ...(userProfile?.lastName && { lastname: userProfile?.lastName }),
      ...(userProfile?.email && { email: userProfile?.email }),
      ...(userProfile?.phone && { phone: userProfile?.phone }),
    });

    setMeetingLink(
      `https://meetings.hubspot.com/odinmortgage/portal-health-check-link?${params}`,
    );
  }, [userProfile]);

  return (
    <Modal
      onOk={onOk}
      open={isOpen}
      onCancel={onClose}
      style={{ top: 20, width: 800 }}
      width={800}
      footer={null}
      cancelText="Close"
      okText="Done"
      title={
        <Typography.Title level={4}>
          Do you want to book a meeting?
        </Typography.Title>
      }
    >
      <Meeting meetingUrl={meetingLink} />
    </Modal>
  );
};

export default HealthCheckMeetingModal;
